import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ORGANIZATION_ID } from '@context/frontend/common';
import { iif, of, switchMap } from 'rxjs';
import { AuthService } from '../services';

const HeaderKey = 'Authorization';
export function authBearerInterceptor(
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
) {
	const auth = inject(AuthService);

	const organizationId$ = inject(ORGANIZATION_ID);
	const organizationId = organizationId$.value;

	const firebaseUser = auth.firebaseUser();
	if (!firebaseUser) return next(req);

	return iif(
		() => !req.headers.has(HeaderKey),
		new Promise((resolve) =>
			firebaseUser.getIdToken().then((token) => {
				if (!token) return resolve(null);

				let headers = req.headers.set(HeaderKey, `Bearer ${token}`);
				if (organizationId) {
					headers = headers.set('Organization', organizationId);
				}

				req = req.clone({ headers });
				return resolve(req);
			}),
		),
		of(null),
	).pipe(switchMap(() => next(req)));
}
